// This function allow to reference async chunks
__webpack_require__.u = function(chunkId) {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"54":"bd5df88d","180":"8853156f","208":"aae1fa22","631":"8d87b8ca","774":"75505424","787":"f33eb9a5","820":"6fca14f1","851":"4e26a760"}[chunkId] + ".chunk.js";
};